import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './notify_list_show.routes';
import CompanyNotifyListService from '../../../../components/api/company_notify_list/company_notify_list.service';
import MailTestService from '../../../../components/api/mail_test/mail_test.service';
import CompanyService from '../../../../components/api/company/company.service';
import UniqueValidator from '../../../../components/directive/unique_validator/unique_validator.directive';

export class OemNotifyListShowController {
    /*@ngInject*/
    constructor($scope, $state, $stateParams, $mdDialog, CompanyNotifyListService, MailTestService, CompanyService) {
        this.id = $stateParams.company_id;
        this.emails = [];
        this.inputMail = '';
        this.isTestMailSending = false;
        this.isMailTestSuccessed = false;

        this.NotifyListService = CompanyNotifyListService;
        this.MailTestService   = MailTestService;
        this.CompanyService    = CompanyService;
        this.$mdDialog         = $mdDialog;
        this.$state = $state;

        $scope.$watch('$ctrl.inputMail', this.resetStatus());
    }

    $onInit() {
        this.CompanyService.show({ id: this.id }, response => {
            this.company_name = response.name;
        }, err => {
            if(err.status === 404 || err.status === 403) { this.$state.go('oem_main.oem_home'); }
        });

        this.NotifyListService.api.show({ id: this.id }, response => {
            this.emails = response.emails;
        });
    }

    deleteMail(email) {
        let targetIndex = this.emails.indexOf(email);
        this.emails.splice(targetIndex, 1);
        this.NotifyListService.api.update({ id: this.id, emails: this.emails });
    }

    addMail(email) {
        this.emails.push(email);
        this.inputMail = '';

        this.NotifyListService.api.update({ id: this.id, emails: this.emails });
    }

    sendTestMail(email) {
        let dialog = {
            confirm: this.$mdDialog.confirm({
                clickOutsideToClose:true,
                title: `${email}宛にテストメールを送信します`,
                ok: '送信する',
                cancel: '戻る'
            }),
            error: this.$mdDialog.alert({
                clickOutsideToClose:true,
                title: 'エラーが発生しました',
                content: 'メールアドレスを確認してください',
                ok: 'OK'
            })
        };

        this.$mdDialog.show(dialog.confirm).then(() => {
            this.isTestMailSending = true;
            this.MailTestService.oem_api.create(
                {　test_mail: email　},
                okResponse => {
                    this.isMailTestSuccessed = true;
                },
                ngResponse => {
                    this.resetStatus();
                    this.$mdDialog.show(dialog.error);
                }
            );
        });
    }

    resetStatus() {
        return () => {
            if(this.isTestMailSending || this.isMailTestSuccessed) {
                this.isTestMailSending   = false;
                this.isMailTestSuccessed = false;
            }
        }
    }
}

export default angular.module('leptonApp.oemNotifyListShow', [uiRouter, CompanyNotifyListService, MailTestService, CompanyService, UniqueValidator])
    .config(routing)
    .component('oemNotifyListShow', {
        template: require('./notify_list_show.html'),
        controller: OemNotifyListShowController
    })
    .name;



// WEBPACK FOOTER //
// ./public/dev/app/oem/notify_list/show/notify_list_show.component.js